<template>
  <div class="card">
    <el-carousel height="300px">
      <el-carousel-item  v-for="(t, i) in data.thumbnails" :key="i" >
        <img class="card-img-top" :src="api_files + t.id" :alt="t.name">
      </el-carousel-item>
    </el-carousel>
    <el-divider></el-divider>
    <div class="card-body p-0">
      <h4 class="card-title">{{data.name}}</h4>
      <p class="card-text">{{data.summary}}</p>
      <h4>$ {{data.ammount_total}}</h4>  
      <span>Finaliza el </span> <strong>{{data.end_at}}</strong>
    </div>
    <div class="col-md-12 text-center">
      Recaudado
      <br>
      <el-progress 
      :text-inside="true"
      :stroke-width="23"
      :percentage="data.ammount_recauded_percentage ? data.ammount_recauded_percentage : 0" 
      :status="type(data.ammount_recauded_percentage)"
      ></el-progress>
    </div>
    <br>
    <br>
    <router-link
      v-if="showbutton"
      :to="{ name: 'detail', params: { id: data.id }}"
      class="btn btn-simple btn-round btn-white btn-lg"
    >
      {{$t('detail.button_more')}}
    </router-link>
  </div>
</template>
<script>
import { Card } from '@/components';
import { Divider, Button, MessageBox, Message, Carousel, CarouselItem, Progress } from 'element-ui';
import _ from 'lodash'

import Settings from '@/providers/Settings'
const provider = new Settings()

export default {
  name: 'project-view',
  components: {
    Card,
    [Progress.name]: Progress,
    [Button.name]: Button,
    [Divider.name]: Divider,
    [Carousel.name]: Carousel,
    [CarouselItem.name]: CarouselItem
  },
  data() {
    return {
      api_files: this.$store.state.api_files
    }
  },
  methods: {
    type(percentage){
      if (percentage) {
        if (percentage < 25) {
          return 'info'
        } else if (percentage > 25 && percentage <= 50) {
          return 'warning'
        } else if (percentage > 50) {
          return 'success'
        }
      }else {
        return 'info'
      }
    }
  },
  props: {
    data:{
      type: Object
    },
    showbutton: {
      type: Boolean,
      default: true
    }
  }
};
</script>
<style>

</style>